import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrincipalMessage = () => {
  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Our School
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                Principal's <span className="font-bold">Message</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                A personal welcome from Principal Daisy Joy-Rodrigo to the P.S. 11X family.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Principal's Message Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl p-8 lg:p-12 shadow-xl border border-gray-100 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] via-[#8B4513] to-[#A0522D]"></div>
            
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Principal's Message</h2>
              <div className="w-24 h-px bg-[#630503]/40 mx-auto"></div>
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Welcome to the P.S. 11x Family- the home of Bronx Brilliance and the number one school in The Bronx! It is my great honor and pride to serve the Highbridge community as principal. P.S. 11x is a truly special place. From the moment you walk through the door, you feel like you are home. Our message to our entire community centers around the feeling of belonging. At P.S. 11x, you belong here!
              </p>

              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                The idea of Bronx Brilliance is centered around the idea that we all have gifts and talents. This lives in each and every one of us. Imagine if school became the place where scholars and staff can explore, learn and share some of our gifts and talents. What would school look like? What would school feel like? How would that impact teaching and learning? How would it impact attendance?
              </p>

              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                P.S. 11x Highbridge community is where greatness begins, and dreams are built. I believe in the brilliance that exists in the Bronx, as I was once part of this community as a child. It has always been my childhood dream to return to the Bronx community that welcomed my immigrant parents as they started out life in America. I am proud to say that I am back home in District 9!
              </p>

              <p className="text-lg text-gray-700 leading-relaxed mb-12">
                Come and visit us at P.S. 11x, where collaboration is our strength and commUNITY is our guide.
              </p>

              <div className="text-center">
                <div className="w-96 h-96 mx-auto mb-6 rounded-full overflow-hidden border-4 border-[#630503]/20 shadow-lg">
                  <img
                    src="/assets/images/principalmessage/rodrigo.jpg"
                    alt="Principal Daisy Joy-Rodrigo"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-lg text-gray-700 italic mb-2">In Unity,</p>
                <p className="text-xl font-bold text-[#630503]">Principal Daisy Joy-Rodrigo</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bronx Brilliance Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Bronx <span className="font-bold text-[#630503]">Brilliance</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Where greatness begins and dreams are built
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Belonging */}
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] to-[#8B4513]"></div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-4">You Belong Here</h3>
                <div className="w-16 h-px bg-[#630503]/40 mx-auto mb-6"></div>
                <p className="text-gray-700 leading-relaxed">
                  From the moment you walk through the door, you feel like you are home. Our message centers around the feeling of belonging.
                </p>
              </div>
            </div>

            {/* Gifts & Talents */}
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#8B4513] to-[#A0522D]"></div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Gifts & Talents</h3>
                <div className="w-16 h-px bg-[#8B4513]/40 mx-auto mb-6"></div>
                <p className="text-gray-700 leading-relaxed">
                  We all have gifts and talents that live in each and every one of us. School is where we explore, learn and share these gifts.
                </p>
              </div>
            </div>

            {/* Community Unity */}
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#A0522D] to-[#630503]"></div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-4">CommUNITY</h3>
                <div className="w-16 h-px bg-[#A0522D]/40 mx-auto mb-6"></div>
                <p className="text-gray-700 leading-relaxed">
                  Collaboration is our strength and commUNITY is our guide. Together we build greatness and achieve dreams.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default PrincipalMessage; 